module.exports = __webpack_public_path__ + "static/img/_5.73f3990.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_5.png
// module id = q/bm
// module chunks = 1